import React, { memo } from 'react';
import clsx from 'clsx';

import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';
import { CONTENT_VIEW } from '../../constants';

import scss from './ContentViewSwitch.module.scss';

const ContentViewSwitch = ({ onChangeContentView, contentView }) => {
  return (
    <div className={scss.contentViewSwitch}>
      <button
        className={clsx(scss.switchIcon, contentView === CONTENT_VIEW.CARDS && scss.switchIconActive)}
        onClick={() => onChangeContentView(CONTENT_VIEW.CARDS)}>
        <Icon icon={ICONS.CardsView} disableCommonColors />
      </button>

      <button
        className={clsx(scss.switchIcon, contentView === CONTENT_VIEW.TABLE && scss.switchIconActive)}
        onClick={() => onChangeContentView(CONTENT_VIEW.TABLE)}>
        <Icon icon={ICONS.TableView} disableCommonColors />
      </button>
    </div>
  );
};

export default memo(ContentViewSwitch);
